  import Enum from './enum'

class Currency extends Enum
{
  constructor(value) {
    super(value);
  }
}

Currency.init({
  EMPTY: 'None',
  BYN: 'BYN',
  RUB: 'RUB',
  USD: 'USD',
  EUR: 'EUR',
  CNY: 'CNY'
}, {
  EMPTY: 'currency.none',
  BYN: 'currency.byn',
  RUB: 'currency.rub',
  USD: 'currency.usd',
  EUR: 'currency.eur',
  CNY: 'currency.cny'
},{
  BYN: ['BYN'],
  NOT_BYN: ['RUB', 'USD', 'EUR', 'CNY'],
  NOT_EMPTY: ['BYN', 'RUB', 'USD', 'EUR', 'CNY']
});

export default Currency;
